"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getVimeoUrl;

function getVimeoUrl(url) {
  var match = url.match(/vimeo.com\/(\w+$)/);
  var videoId = match && match[1];
  return videoId && "https://player.vimeo.com/video/".concat(videoId);
}